<template>
  <BaseEditModal
    displayName="Logs"
    helpFileName="CreateSceneModal"
    :tabs="tabs"
    :icon="'mdi-text-box-search-outline'"
    :hideTabs="true"
    hideBottomButtons
    @close="emit('close')"
    @locked="(bool) => emit('locked', bool)"
    @activeTab="handleTabChange"></BaseEditModal>
</template>
<script setup>
import { ref, watch } from 'vue';
import { deluge } from '@/stores/deluge.js';
import BaseEditModal from '../Shared/Modals/BaseEditModal.vue';
import { $http } from '@/stores/http.js';
import Logger from './Logger.vue';
const tabs = [
  {
    id: 0,
    title: 'General System Logs',
    icon: 'mdi-text-box-search-outline',
    display: true,
    component: Logger,
  },
];
</script>
